import { HubConnectionBuilder, HubConnection } from '@microsoft/signalr';
import { Dispatch } from 'redux';
import { connect, disconnect, addConnection, deleteConnection } from '../contexts/slices/signalr';
import { newToast } from '../components';
import { formatMessage } from 'devextreme/localization';

let connection: HubConnection | null = null;

const getUrl = async () => {
    const configUrl = '/config.json';
    const response = await fetch(configUrl);
    const config = await response.json();
    return config.singnalRUrl;
};

let urlPromise: Promise<string> | null = null;

export async function startSignalRConnection(dispatch: Dispatch, signalRUrlParam?: string) {
    if (connection) {
        return;
    }
    
    let url: string;
    if (signalRUrlParam) {
        // Si se proporciona la URL desde Redux, usarla
        url = signalRUrlParam;
    } else {
        // Fallback: obtener desde config.json (cacheado)
        if (!urlPromise) {
            urlPromise = getUrl();
        }
        url = await urlPromise;
    }
    connection = new HubConnectionBuilder()
        .withUrl(`${url}/dataChangeHub`)
        .withAutomaticReconnect()
        .build();
    try {
        await connection.start().catch(err => {
        });
        const connectionId = connection.connectionId;
        if (!connectionId) {
            return
        }
        console.log('Conectado web socket dataChange....')

        connection.onreconnected(()=>{
            dispatch(connect(connectionId))
            newToast('SUCCESS',formatMessage("conexStatusOk"),3)
        })

        connection.onreconnecting(() => {
            console.log('Intentando restablecer la conexión con el servidor...');
            newToast('ERROR',formatMessage("conexStatusError"),3)
            dispatch(disconnect())
        });

        dispatch(connect(connectionId))
        addConnection(connectionId, connection)
    } catch (error) {
        newToast('ERROR', 'Se ha perdido la conexión', 5);
    }
}


export async function stopSignalRConnection(dispatch: Dispatch) {
    if (!connection) {
        console.log('null conex')
        return;
    }
    try {
        dispatch(disconnect());
        const connectionId = connection.connectionId;
        if (!connectionId) {
            return
        }
        deleteConnection(connectionId)
        await connection.stop();
        connection = null;
        console.log('Desconectado web socket dataChange...')
    } catch (error) {
        newToast('ERROR', 'Error al desconectar', 5);
    }
    finally {
        startSignalRConnection(dispatch)
    }
}
